import React from "react";

export const Brand = ({ className = "" }) => (
  <div className={`brand ${className}`}>
    <img src="/logo.png" alt="Xandi Beauty and Wellness Hub logo" className="brand-mark" />
    <div className="logo">
      <span className="lg-name">Xandi</span>
      <span className="lg-tag">Beauty &amp; Wellness Hub</span>
    </div>
  </div>
);

export default Brand;
